import { Box, Checkbox, Paper, Skeleton } from "@mui/material";
import { DataGrid, GridColDef, GridPaginationModel, GridRenderCellParams, GridSortModel, useGridApiRef } from "@mui/x-data-grid";
import {useEffect, useState} from "react";
import tripService from "services/tripService";
import { Trip, TripSearchFlattenedOptions } from "trips/models";
import { VehicleSearch } from "vehicles/models";
import { Link } from "react-router-dom";
import { PagedResults } from "common/models";

const VehicleTrips = ({unitNumber})=>{

    const [search, setSearch] = useState<TripSearchFlattenedOptions>({offset:0, pageSize:20, sort:'pickup', sortDirection: 'desc',unitNumber });
    const [trips, setTrips] = useState<Trip[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(true);
    const gridRef = useGridApiRef();

    useEffect(()=>{
        if(!unitNumber)return;
        setIsLoading(true);
        setTrips([]);
        tripService.getTrips(search).then(_trips => {
            setTrips(_trips?.results);
            setTotal(_trips.count);
        }).finally(()=> setIsLoading(false));
    },[unitNumber, search]);

    function handleOnChange(e: any) {
        var request = { ...search, [e.target.name]: e.target.value };
        setSearch(request);
        gridRef.current.setPage(0);
      }
    
      const handleSortModelChange = (sortModel: GridSortModel) => {
        if (!(sortModel.length > 0)) return;

        let sortBy = "";
        switch(sortModel[0].field){
          case 'tripNumber':
            sortBy='tripnumber';
            break;
          case 'pickupDateTime':
            sortBy='pickup';
            break;
          case 'pickupLocation':
            sortBy='pickuploc';
            break;
          default:
            sortBy = sortModel[0].field;
            break;
        }
        var request = {
          ...search,
          sort: sortBy,
          sortDirection: sortModel[0].sort,
          offset: 0
        };
        setSearch(request);
        gridRef.current.setPage(0);
      };
    
      const handlePaginationModel = (pagination: GridPaginationModel) => {
        if (pagination.pageSize != search.pageSize) {
          pagination.page = 0;
        }
        setSearch({ ...search,  pageSize: pagination.pageSize, offset: pagination.page });
      };
    
      const LoadingSkeleton = () => (
        <Box
          sx={{
            height: "fit-content",
            padding: "0px",
            margin: "0px",
            overflow: "hidden",
          }}
        >
          {[...Array(search.pageSize)].map((_, index) => (
            <Skeleton key={index} variant="rectangular" width="98%" sx={{ my: 3, mx: 1, overflow: "hidden" }} />
          ))}
        </Box>
      );
      const columns: GridColDef[] = [
        {
            field: "tripNumber",
            headerName: "Trip Number",
            flex: 1,
            renderCell: (params: GridRenderCellParams<any, number>) => (
              <Link to={`/trips/${params.value}`}>
                {params.value}
              </Link>
            ),
          },
        { field: "controlNumber",headerName: "Control Number", flex: 1 },
        { field: "pickupLocation", headerName: "Pickup Location", flex: 1,  renderCell: (params: GridRenderCellParams<any, number>) => params.row.pickupLocation.name},
        { field: "pickupDateTime", headerName: "Pickup Date", flex: 1, renderCell: (params: GridRenderCellParams<any, number>) => new Date(params.row.pickupDateTime).toLocaleString()},
        { field: "driver", headerName: "Driver", flex:1, renderCell: (params: GridRenderCellParams<any, number>) => params.row.driver.name},
      ];

    return(<>
    <Box sx={{ mt: 2, overflow: "hidden" }}>
        <Paper sx={{ width: "99%", height: isLoading ? "100vh" : "auto", overflow: "hidden" }}>
          <DataGrid
            sx={{ overflow: "hidden" }}
            getRowId={(row) => row.tripNumber}
            rows={trips}
            columns={columns}
            pagination
            sortingMode="server"
            paginationMode="server"
            onPaginationModelChange={handlePaginationModel}
            onSortModelChange={handleSortModelChange}
            initialState={{
              pagination: { paginationModel: {page: search.offset, pageSize: search.pageSize }},
              sorting: { sortModel: [{ field: "pickupDateTime", sort: "desc" }] },
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            rowCount={total}
            disableColumnMenu
            slots={{
              loadingOverlay: LoadingSkeleton,
            }}
            loading={isLoading}
            density="compact"
            apiRef={gridRef as any}
            getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd")}
          />
        </Paper>
      </Box>
    </>);
}
export default VehicleTrips;